import React from 'react';
import { colors, spacing, shadows } from '../../../design/tokens';

export const Hero: React.FC<{ user: any; getDashboardPath: () => string }> = ({ user, getDashboardPath }) => {
  return (
    <section style={{ 
      padding: `${spacing.xxl} ${spacing.xl}`, 
      textAlign: 'center', 
      background: 'white',
      color: colors.neutral[900],
      borderBottom: `1px solid ${colors.neutral[200]}`
    }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto', paddingTop: spacing.xxl }}>
        
        <h1 style={{ fontSize: '64px', fontWeight: 800, marginBottom: spacing.lg, color: colors.neutral[1000], letterSpacing: '-0.04em', lineHeight: 1.05 }}>
          Fix Code Vulnerabilities <br />
          <span style={{ color: colors.brand.main }}>Automatically</span>
        </h1>
        
        <p style={{ fontSize: '20px', maxWidth: '750px', margin: '0 auto', color: colors.neutral[600], lineHeight: 1.6, marginBottom: spacing.xl }}>
          Exibrain is an AI-powered security engine that scans codebases, writes validated fixes, and runs tests. Ship stable, secure code faster than ever.
        </p>
        
        <div style={{ display: 'flex', gap: spacing.md, justifyContent: 'center', marginBottom: spacing.xxl }}>
          <a href={user ? getDashboardPath() : "/signup"} style={{ 
            padding: `16px 40px`, 
            backgroundColor: colors.neutral[1000], 
            color: 'white', 
            borderRadius: '8px', 
            textDecoration: 'none', 
            fontWeight: 700,
            fontSize: '18px',
          }}>{user ? "Go to Dashboard" : "Get Started Now"}</a>
        </div>

      </div>
    </section>
  );
};
